<template>
  <div class="text-center pa-4" style="padding: 25px 50px 50px 50px !important;">
    <v-row class="">
      <v-col cols="12" style="color: #0d0d60;
        font-size: 1.5rem !important;
        font-weight: 800 !important; text-align: left;">
        Documents
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div v-if="allDoc && allDoc.company_document_counts && allDoc.company_document_counts.length">
            <h3 class="mb-0 mt-0 text-left pl-3" style="font-weight: 600; padding-top: 10px;">Company document</h3>
            
            <v-row class="w-100 ma-0">
                <v-col cols="4" v-for="(com, c) in allDoc.company_document_counts" :key="c">
                    <div v-if="allDoc && allDoc.company_document_counts" class="hover-elevation bg-white v-card v-sheet theme--light mb-6" style="box-shadow: none; border-radius: 24px;    padding: 24px;     box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);">
                    <h3 class="mb-6">{{ com.company_name }}</h3>
                    <p @click="openDialog(com)" style="    color: #878a99;
    font-size: 14px;
    font-weight: 400;
    text-decoration: underline; cursor: pointer;">{{ com.document_count }} Documents</p>
                    </div>
                </v-col>
            </v-row>
            <h3 class="mb-0 mt-0 text-left pl-3" style="font-weight: 600; padding: 12px 0;">Recent documents</h3>
                
            <div v-if="allDoc && allDoc.company_document_counts" class="hover-elevation bg-white v-card v-sheet theme--light" style="box-shadow: none; border-radius: 24px;">
                <v-row class="tableHead w-100 ma-0">
                    <v-col cols="4" class="pa-0 text-left">
                        Document
                    </v-col>
                    <v-col cols="3" class="pa-0 text-left">Company</v-col>
                    <v-col cols="4" class="pa-0 text-left">Uploaded
                        <v-row>
                            <v-col cols="6">
                                <small style="font-weight:400;">By</small>
                            </v-col>
                            <v-col cols="6">
                                <small style="font-weight:400;">Date</small>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="1" class="pa-0 text-left">Download</v-col>
                </v-row>
                <div class="log" style="height: 60vh; overflow-y: auto;">
                    <v-row class="w-100 ma-0 text-left" style=" border-top: 1px solid rgb(233, 235, 236) !important;" v-for="(log, l) in allDoc.recent_documents" :key="l">
                        <v-col cols="4">
                            {{ log.title }}<br>
                            <small>{{ log.description }}</small>
                        </v-col>
                        <v-col cols="3">
                            {{ log.company.company_name }}
                        </v-col>
                        <v-col cols="4">
                            <v-row>
                            <v-col cols="6">
                                <small style="font-weight:400;">{{ log.created_by.display_name }}</small>
                            </v-col>
                            <v-col cols="6">
                                <small style="font-weight:400;">{{ moment(log.created_at).format('DD MMM YYYY') }}</small>
                            </v-col>
                        </v-row>
                            
                        </v-col>
                        <v-col>
                          <v-btn @click="downloadFile(log.document_url)" text icon class="btn-soft-success">
                                <v-icon>mdi-file-download</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </div>
                   
        </div>
        <div v-else class="firstNew" style="width:100%;background: white;border-radius: 10px; height: 300px;; ">
          <p class="text-center" style="    color: rgb(135, 136, 136);
        padding: 75px;
    margin: 0px;
    text-align: center !important;">No documents available</p>
        </div>
      </v-col>
    </v-row>
    <v-dialog
      v-model="docDialog"
      persistent
      max-width="1000"
    >
      <v-card>
        <v-card-title class="text-h5">
          <v-row class="w-100 ma-0">
            <v-col cols="6" class="pa-0">
              Document(s)
            </v-col>
            <v-col cols="6" class="pa-0 text-right">
              <v-btn text @click="docDialog = false;">Close</v-btn>
            </v-col>
          </v-row>
          
        </v-card-title>
        <div v-if="allCompanyDoc && allCompanyDoc.documents" class="hover-elevation bg-white v-card v-sheet theme--light" style="box-shadow: none; border-radius: 24px;    padding: 24px;">
                <v-row class="tableHead w-100 ma-0">
                    <v-col cols="4" class="pa-0 text-left">
                        Document
                    </v-col>
                    <v-col cols="3" class="pa-0 text-left">Company</v-col>
                    <v-col cols="4" class="pa-0 text-left">Uploaded
                        <v-row>
                            <v-col cols="6">
                                <small style="font-weight:400;">By</small>
                            </v-col>
                            <v-col cols="6">
                                <small style="font-weight:400;">Date</small>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="1" class="pa-0 text-left">Download</v-col>
                </v-row>
                <div class="log" style="height: 60vh; overflow-y: auto;">
                    <v-row class="w-100 ma-0 text-left" style=" border-top: 1px solid rgb(233, 235, 236) !important;" v-for="(log, l) in allCompanyDoc.documents" :key="l">
                        <v-col cols="4">
                            {{ log.title }}<br>
                            <small>{{ log.description }}</small>
                        </v-col>
                        <v-col cols="3">
                            {{ log.company.company_name }}
                        </v-col>
                        <v-col cols="4">
                            <v-row>
                            <v-col cols="6">
                                <small style="font-weight:400;">{{ log.created_by.display_name }}</small>
                            </v-col>
                            <v-col cols="6">
                                <small style="font-weight:400;">{{ moment(log.created_at).format('DD MMM YYYY') }}</small>
                            </v-col>
                        </v-row>
                            
                        </v-col>
                        <v-col>
                          <v-btn @click="downloadFile(log.document_url)" text icon class="btn-soft-success">
                                <v-icon>mdi-file-download</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import axios from 'axios';
import moment from 'moment';
import 'sweetalert2/dist/sweetalert2.min.css';
import Vue from 'vue';
import InfiniteLoading from 'vue-infinite-scroll';
import VueSweetalert2 from 'vue-sweetalert2';
import { mapState } from 'vuex';
import addCompany from './dialogs/AddCompany';
var count = 0;

  Vue.use(VueSweetalert2);
  am4core.useTheme(am4themes_animated);
  export default {
    name: 'Dashboard',

    components: {
      axios,
      InfiniteLoading,
      addCompany
    },

    data: () => ({
      allDoc: null,
      docDialog: false,
      allCompanyData: null,
      allCompanyDoc: null,
      moment: moment
    }),
    watch : {
    },
  methods: {
    openDialog (data) {
      this.allCompanyData = data;
      this.getSelectedCompanyDocs(data.company_id);
      this.docDialog = true;
    },
    getSelectedCompanyDocs(data) {
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.get(`${process.env.VUE_APP_API_URL}company/vault?company_id=${data}`, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.allCompanyDoc = response.data;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.config.savingStage = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
    downloadFile (url) {
        if (url) {
          window.open(url);
        } else {
          this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Download file access denied!'
          });
        }
    },
    getCompanyDocs(id) {
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.get(`${process.env.VUE_APP_API_URL}company/vault`, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.allDoc = response.data;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.config.savingStage = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
  },
    mounted () {
        this.getCompanyDocs(this.$route.query.cid);
    }
  }
</script>
<style lang="scss" >
.filterDrawer .v-icon.v-icon {
  font-size: 14px !important;
}
.filterDrawer .v-input--selection-controls {
  margin-top: 0px !important;
}
.image-preview:hover .overlay1 {
  display: block;
}
.image-preview:hover .overlay2 {
  display: block;
}
.overlay1 {
  display: none;
  position: absolute; 
  bottom: 0; 
  background: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.5); /* Black see-through */
  width: 100%;
  cursor:pointer;
  transition: .5s ease;
  opacity:1;
  font-size:16px;
  color: white;
  padding: 10px 0;
  text-align: center;
}
.overlay2 {
  display: none;
  position: absolute; 
  bottom: 0; 
  background: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.5); /* Black see-through */
  width: 100%;
  cursor:pointer;
  transition: .5s ease;
  opacity:1;
  font-size:16px;
  color: white;
  padding: 10px 15px 15px 15px;
  text-align: center;
}
input[type=file] {
  cursor: pointer;
  width: 130px;
  height: 130px;
  padding:10px;
  border-radius: 10px;
  overflow: hidden;
  background: #f1f1f1;
}

input[type=file]:before {
  content: 'Drag and drop \A or \A click to add \A avatar';
  vertical-align: middle;
  white-space: pre-wrap;
  text-align: center;
  font-size: .8em;
  display: inline-block;
  background: #f1f1f1;
  padding: 20% 10px;
  font-family: Helvetica, Arial, sans-serif;
}

input[type=file]::-webkit-file-upload-button {
  visibility: hidden;
}
.heading {
  font-size: 16px;
  padding-top:10px;
}
.dashboardCount {
  font-size: 70px;
  padding:10%;
}
.mainBox {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 4px 16px 11px rgb(0 0 0 / 6%), 0 4px 8px rgb(0 0 0 / 10%) !important;
  height: 16rem;
  transition: 0.5s;
  -webkit-transition: 0.5s;
  text-align: center;
}
.v-btn--active {
  background-color: #050550 !important;
}
.disabledView {
  .v-btn--active {
    background-color: #858585 !important;
  }
}
#chartdiv1 {
  height: 360px;
  width:100%;;
}

.primary--text {
  color: #050550 !important;
}
#chartdiv {
  width: 100%;
  height: 210px;
  
}
.headingprofile {
  text-align: left;
  h2 {
    color: #263238;
    font-weight: 500;
    line-height: 1.1;
    font-size: 20px;
    margin: 0 0 6px;
    width: 100%;
  }
}
.firstNew::before {
    background: #fff none repeat scroll 0 0;
    content: "";
    height: 100%;
    left: 0;
    opacity: 0.8;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;
}
.overlay {
  position: absolute; 
  bottom: 0; 
  background: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.3); /* Black see-through */
  width: 100%;
  transition: .5s ease;
  opacity:1;
  font-size:16px;
  color: white;
  padding: 72% 0 20% 0;
  text-align: center;
}
::-webkit-scrollbar-track
{
	// -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #ffffff;
}

::-webkit-scrollbar
{
	width: 12px;
	background-color: #ffffff;
}

::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	background-color: #ccc;
}
.v-timeline-item__inner-dot {
  .v-icon {
    color: #263238;
  }
}
.filterButton {
  text-transform: capitalize;
  border-radius:6px;
  box-shadow: none !important;
    color: #10b981 !important;
    background: #daf4f0 !important;
    border-color: transparent;
}
.filterButton:hover {
  box-shadow: none !important;
  color: white !important;
  background: #10b981 !important;
  border-color: transparent !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}
.v-btn-toggle--group > .v-btn.v-btn {
  margin-left: 0px !important;
  margin-right:0px !important;
  border-color: #d7d7d7 !important;
}
.v-btn-toggle > .v-btn.v-btn--active {
  background-color: #10b981 !important;
  color: white !important;

}
.hover:hover {
  background-color: #10b981;
    color: white;
    position: relative;
    padding: 10px;
    display:flex;
}
.hover:hover::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background-color: #10b981;
}
.toggleButton {
    text-transform: capitalize; 
}
.responsive-avatar {
    width: 100%;
    height: 100%;
    max-width: 140px;
    max-height: 140px;
    min-width: 80px;
    min-height: 80px;
}

.responsive-avatar img {
    width: 100%;
    height: auto;
    border-radius: 50%;
}
.am-card {
  height: 13rem;
  padding: 25px 15px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}
</style>
